export default {
	count: '/api/delivery/monitoring/count',
	list: '/api/delivery/monitoring/list',
	search: '/api/delivery/monitoring/search',
	providers: '/api/delivery/monitoring/providers',
};
